import React from 'react';
import './App.css';
import { PlatformMessagesWrapper } from './services/platformMessagesWrapper';
import { init } from './core/init';
import Game from './containers/common/game';

function App() {
  init();

  return (
    <div>
      <PlatformMessagesWrapper>
        <Game />
      </PlatformMessagesWrapper>
    </div>
  );
}

export default App;
